import React from 'react';
import { CSS } from '@dnd-kit/utilities';
import { useSortable } from '@dnd-kit/sortable';

export interface DraggableRowProps
  extends React.HTMLAttributes<HTMLTableRowElement> {
  'data-row-key': string;
  isDnDDisabled: boolean;
}

const DraggableRow: React.FC<Readonly<DraggableRowProps>> = (props) => {
  const { isDnDDisabled, ...domProps } = props;
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: domProps['data-row-key'],
    disabled: isDnDDisabled,
  });

  const style: React.CSSProperties = {
    ...domProps.style,
    transform: CSS.Translate.toString(transform),
    transition,
    ...(isDragging
      ? { position: 'relative', zIndex: 9999, pointerEvents: 'none' }
      : {}),
  };

  return (
    <tr
      {...domProps}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    />
  );
};

export default DraggableRow;
